import React, { useRef } from "react";
import { useEffect, useState } from "react";
import {
  initializeChatHub,
  joinChatRoom,
  sendMessage,
  onReceiveMessage,
  leaveChatRoom,
  onReceiveSOS,
  sendSOSAlert,
} from "../../../../../Service/signalRService";
import {
  Box,
  Avatar,
  Typography,
  IconButton,
  InputBase,
  Paper,
  Button,
  Modal,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  DialogActions,
} from "@mui/material";
import {
  MoreVert,
  AttachFile,
  Mic,
  Send,
  DeleteForeverRounded,
  CurrencyRupee,
  Campaign,
} from "@mui/icons-material";
import { CaseListType } from "DataTypes/Case.type";
import { UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { SingleMessageType } from "DataTypes/Chat.type";
import ImgPath from "Constants/Imgs";
import ChatApi from "Service/Chat.api";
import { msgFormatter } from "./Formatter";
import NoData from "Components/NoData";
import dayjs from "dayjs";
import AudioComponent from "./AudioComponent";
import AttachmentComponent from "./AttachmentComponent";
import { MeetingApi } from "Service/Meeting.api";
import { useDispatch } from "react-redux";
import {
  setAlertData,
  startLoading,
  stopLoading,
} from "../../../../../Redux/Screen/Action";
import { FormDataType } from "DataTypes/Form";
import { MeetingCreationFormArr } from "./Data";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { HandleFormChange, ValidateFormData } from "Utils/Common";
import StatusUpdateModal from "Components/StatusUpdateModal";
import StatusApi from "Service/Status.api";
import ReportIcon from "@mui/icons-material/Report";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PaymentApi from "Service/Payment.api";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useSearchParams } from "react-router-dom";
export interface SingleChatPropType {
  selectedCase: CaseListType | null;
}

// Outside the component or as a ref to prevent re-creation
const sosSound = new Audio("/Assets/audio/siren.mp3");

const SingleChatScreen1 = (props: SingleChatPropType) => {
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const dispatch = useDispatch();
  const { selectedCase } = props;
  const [input, setInput] = useState("");
  const [openModal, setOpenMoadal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [messages, setMessages] = useState<SingleMessageType[]>([]);
  const [formData, setFormData] = useState<FormDataType[]>([]);
  const [selectedDocument, setSelectedDocument] = useState<{
    url: string | null;
    docType: "video" | "image" | null;
  }>({
    url: null,
    docType: null,
  });
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder | null>(
    null
  );
  const [recordingChunks, setRecordingChunks] = useState<Blob[]>([]);
  const [recordedAudioUrl, setRecordedAudioUrl] = useState<string | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  const [analyserNode, setAnalyserNode] = useState<AnalyserNode | null>(null);
  const caseId = selectedCase?.caseId;
  const senderUserId = myInfo?.id;
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [caseStatus, setCaseStatus] = useState<any[]>([])

  // 1. Add these states at the top of your component
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [isGeneratingLink, setIsGeneratingLink] = useState(false);
  // const [searchParams] = useSearchParams();
  // const [activeCaseId, setActiveCaseId] = useState<number | null>(null);

  //   useEffect(() => {
  //     console.log("selectedCase?.caseId in index1", selectedCase);
  //   if (selectedCase?.caseId) {
  //     const saved = localStorage.getItem("unread_notifications");
  //     if (saved) {
  //       const notifications = JSON.parse(saved);
  //       const filtered = notifications.filter((n: any) => n.caseId !== selectedCase.caseId);
  //       localStorage.setItem("unread_notifications", JSON.stringify(filtered));
  //       window.dispatchEvent(new Event("notificationsUpdated"));
  //     }
  //       handleFetchChatHistory();
  //       handleInitialLoad();
  //   }
  // }, [selectedCase?.caseId]);

  // Inside SingleChatScreen1 component

  useEffect(() => {
    console.log("selectedCase?.caseId in index1", selectedCase);
    if (selectedCase?.caseId) {
      const clearCurrentCaseNotifications = () => {
        const saved = localStorage.getItem("unread_notifications");
        if (saved) {
          const notifications = JSON.parse(saved);
          // Remove notifications that match the currently open caseId
          const filtered = notifications.filter(
            (n: any) => Number(n.caseId) !== Number(selectedCase.caseId)
          );

          // Only update if something actually changed to avoid infinite loops
          if (notifications.length !== filtered.length) {
            localStorage.setItem("unread_notifications", JSON.stringify(filtered));
            // Notify Topbar to refresh its badge count
            window.dispatchEvent(new Event("notificationsUpdated"));
          }
        }
      };

      // Clear once on load/switch
      clearCurrentCaseNotifications();

      // Set up an interval or listener if you want to ensure 
      // it stays clear while the tab is active
      const interval = setInterval(clearCurrentCaseNotifications, 2000);

      return () => clearInterval(interval);
    }
  }, [selectedCase?.caseId]);

  useEffect(() => {
    if (!caseId || !senderUserId) return;
    const token = localStorage.getItem("token") || "";

    if (caseId) {
      // 1. Get existing notifications from localStorage
      const saved = localStorage.getItem("unread_notifications");
      if (saved) {
        const notifications = JSON.parse(saved);

        // 2. Filter out any notifications matching the current caseId
        const filtered = notifications.filter((n: any) => n.caseId !== Number(caseId));

        // 3. Save back to localStorage
        localStorage.setItem("unread_notifications", JSON.stringify(filtered));

        // 4. Dispatch a custom event to tell the Topbar to refresh its state
        window.dispatchEvent(new Event("notificationsUpdated"));
      }
    }

    // 1. Initialize/Ensure connection is active
    initializeChatHub(token).then(() => {
      // 2. Join the specific case room
      joinChatRoom(caseId.toString());

      // 3. Listen for regular messages
      onReceiveMessage((message) => {
        const formattedMsg = msgFormatter(message);
        setMessages((prev) => [...prev, formattedMsg]);

        // --- NEW: Clear notifications immediately for this case since chat is open ---
        const saved = localStorage.getItem("unread_notifications");
        if (saved) {
          const notifications = JSON.parse(saved);
          const filtered = notifications.filter((n: any) => Number(n.caseId) !== Number(caseId));
          localStorage.setItem("unread_notifications", JSON.stringify(filtered));
          window.dispatchEvent(new Event("notificationsUpdated"));
        }
      });

      // 4. Listen for SOS specifically within this room (optional, 
      // since Topbar also handles the global alert)
      onReceiveSOS((data) => {
        const sosSystemMsg = {
          messageContent: "🚨 SOS: Admin assistance has been requested.",
          senderUserId: 0,
          messageType: "text",
          timestamp: new Date().toISOString(),
          link: `/chat/`
        };
        setMessages((prev) => [...prev, msgFormatter(sosSystemMsg)]);
      });
    });

    handleFetchChatHistory();
    handleInitialLoad();

    return () => {
      leaveChatRoom(caseId.toString());
      console.log("Left chat room group, but connection remains for global alerts.");
    };
  }, [caseId, senderUserId]);

  const handleSOSRequest = async () => {
    if (!caseId || !senderUserId) return;
    try {
      await sendSOSAlert(caseId.toString(), senderUserId);
      dispatch(setAlertData({
        alertMessage: "SOS Sent! Admins have been notified.",
        alertVariant: "success",
        openAlert: true,
      }));
    } catch (err) {
      console.error("SOS failed", err);
    }
  };

  const handleInitialLoad = async () => {
    const newArr: FormDataType[] = JSON.parse(
      JSON.stringify(MeetingCreationFormArr)
    );
    newArr[0].value =
      newArr[4].value = ` Meeting for ${selectedCase?.orderType} - ${selectedCase?.caseId} - ${selectedCase?.caseType}`; // Default topic and agenda
    newArr[3].value = "30"; // Default duration
    setFormData(newArr);
  };

  useEffect(() => {
    if (!analyserNode || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const bufferLength = analyserNode.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    const draw = () => {
      if (!isRecording) return;

      analyserNode.getByteTimeDomainData(dataArray);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.beginPath();

      for (let i = 0; i < bufferLength; i++) {
        const x = (i / bufferLength) * canvas.width;
        const y = (dataArray[i] / 128.0) * (canvas.height / 2);
        ctx.lineTo(x, y);
      }

      ctx.strokeStyle = "red";
      ctx.stroke();
      requestAnimationFrame(draw);
    };

    draw();
  }, [analyserNode, isRecording]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape")
        setSelectedDocument({
          docType: null,
          url: null,
        });
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleFetchChatHistory: () => void = async () => {
    const res = await ChatApi.fetchChatHistoryByCaseId({ caseId: caseId });
    if (res?.success) {
      let formatteRes: SingleMessageType[] = res?.data?.map((el: any) => {
        return msgFormatter(el);
      });
      if (myInfo.userType === "ADMIN") {
        formatteRes = formatteRes.filter(
          (el) => el.messageType !== "file" && el.messageType !== "audio"
        );
      }
      if (res?.data?.[0]?.caseTypeId) {
        const status = await StatusApi.caseStatus(res?.data?.[0]?.caseTypeId);
        setCaseStatus(status?.data);
      }
      setMessages(formatteRes);
    }
  };

  const handleSend = async () => {
    if (!caseId || !senderUserId) return;

    // If there's a recorded audio ready to be sent
    if (recordedAudioUrl && recordingChunks.length) {
      const blob = new Blob(recordingChunks, { type: "audio/webm" });
      const res = await ChatApi.handleUploadVoice({
        audioBlob: blob,
        caseId,
        senderUserId,
      });

      if (res?.success && res?.data?.url) {
        await sendMessage(
          caseId,
          senderUserId,
          "",
          "audio",
          `${process.env.REACT_APP_BASE_URL}${res.data.url}`,
          res?.data?.fileName || "voiceMessage.webm"
        );
      }

      // Cleanup after sending audio
      handleDeleteRecording();
      return;
    }

    // Otherwise, send text message
    if (input.trim()) {
      await sendMessage(caseId, senderUserId, input.trim(), "text", "", "");
      setInput("");
    }
  };

  const handleEnterPress: (event: any) => void = (event) => {
    if (event?.keyCode === 13) {
      handleSend();
    }
  };

  const handleStartRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const chunks: Blob[] = [];
      setRecordingChunks([]);
      setRecordedAudioUrl(null);
      setMediaRecorder(recorder);
      setIsRecording(true);

      recorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.push(e.data);
      };

      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/webm" });
        const url = URL.createObjectURL(blob);
        setRecordingChunks(chunks);
        setRecordedAudioUrl(url);
        setIsRecording(false);
      };

      // Setup AnalyserNode for waveform
      const audioContext = new AudioContext();
      const source = audioContext.createMediaStreamSource(stream);
      const analyser = audioContext.createAnalyser();
      source.connect(analyser);
      setAnalyserNode(analyser);

      recorder.start();
    } catch (error) {
      console.error("Recording failed", error);
    }
  };

  const handleStopRecording = () => {
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const handleDeleteRecording = () => {
    setRecordedAudioUrl(null);
    setRecordingChunks([]);
    setMediaRecorder(null);
  };

  const handleAttachmentUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (!files || !caseId || !senderUserId) return;

    try {
      const uploadPromises = Array.from(files).map(async (file) => {
        const res = await ChatApi.uploadAttachment({
          attachmentBlob: file,
          caseId: caseId,
        });

        if (res?.success && res?.data?.url) {
          await sendMessage(
            caseId,
            senderUserId,
            "",
            "file",
            `${process.env.REACT_APP_BASE_URL}${res.data.url}`,
            res?.data?.fileName
          );
        }
      });

      await Promise.all(uploadPromises);
    } catch (err) {
      console.error("One or more attachment uploads failed", err);
    } finally {
      // Clear input so user can select the same files again if needed
      event.target.value = "";
    }
  };

  const downloadImage = async (url: string, fileName: string) => {
    try {
      const response = await fetch(url, {
        mode: "cors",
        cache: "no-cache",
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file.");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode?.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      alert("Download failed. Please try again.");
    }
  };

  const handleCloseCase = async () => {
    setOpenStatusModal(true);
  };

  const handleReOpenCase = async () => { };

  const handleStatusUpdate = async (selectedStatus: any) => {
    try {
      dispatch(startLoading({ loading: true, loadtext: "Updating Status..." }));

      // Here you would call your API to update the case status
      // const res = await CaseApi.updateCaseStatus({
      //   caseId: selectedCase?.caseId,
      //   statusId: selectedStatus.pkProcessingStatus
      // });

      // Send a message to the chat about the status update
      if (selectedCase?.caseId && senderUserId) {
        await sendMessage(
          selectedCase.caseId,
          senderUserId,
          `Case status updated to: ${selectedStatus.statusName}.`,
          "text",
          "",
          ""
        );
      }

      dispatch(
        setAlertData({
          alertMessage: `Case status updated to ${selectedStatus.statusName}`,
          alertVariant: "success",
          openAlert: true,
        })
      );

      dispatch(stopLoading());
    } catch (error) {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Failed to update case status",
          alertVariant: "error",
          openAlert: true,
        })
      );
    }
  };
  const handleCallConnection = async () => {
    dispatch(startLoading({ loading: true, loadtext: "Connecting Call..." }));
    const res = await MeetingApi.ConfrenceCall({
      caseId: selectedCase?.caseId?.toString(),
    });
    if (res?.success) {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage:
            "Call initiated. Please wait, you'll receive a call within 1-2 minutes.",
          alertVariant: "success",
          openAlert: true,
        })
      );
    } else {
      dispatch(stopLoading());
      dispatch(
        setAlertData({
          alertMessage: "Failed to initiate call.",
          alertVariant: "error",
          openAlert: true,
        })
      );
    }
  };

  const handleScheduleMeet: () => void = async () => {
    const validation = ValidateFormData(formData);
    setFormData(validation.formData);
    if (!validation.errorCheck && selectedCase?.caseId) {
      dispatch(
        startLoading({ loading: true, loadtext: "Scheduling Meeting..." })
      );

      const date = formData.find((el) => el.id === "startAt")?.value;
      const time = formData.find((el) => el.id === "startTime")?.value;
      const combinedDateTime = dayjs(
        `${date} ${time}`,
        "YYYY-MM-DD hh:mm A"
      ).format("YYYY-MM-DD hh:mm A");
      const payload: any = {
        caseId: selectedCase?.caseId?.toString(),
        topic: formData.find((el) => el.id === "topic")?.value,
        startAt: combinedDateTime,
        durationInMinutes: formData.find((el) => el.id === "durationInMinutes")
          ?.value,
        agenda: formData.find((el) => el.id === "agenda")?.value,
      };
      const res = await MeetingApi.ScheduleMeeting(payload);
      if (res?.success) {
        await sendMessage(
          selectedCase?.caseId,
          senderUserId ?? 0,
          `Meeting successfully scheduled at ${dayjs(payload.startAt).format(
            "YYYY-MM-DD, hh:mm A"
          )}`,
          "text",
          "",
          ""
        );
        dispatch(
          setAlertData({
            alertMessage: "Meeting scheduled successfully.",
            alertVariant: "success",
            openAlert: true,
          })
        );
        dispatch(stopLoading());
        setOpenMoadal(false);
        handleInitialLoad();
      } else {
        dispatch(stopLoading());
      }
    }
  };

  // 2. Add the submit handler
  const handleSendPaymentLink = async () => {
    if (!amount || isNaN(Number(amount))) return;

    setIsGeneratingLink(true);
    try {
      const response = await PaymentApi.generatePaymentLinkForCase({
        caseId: caseId,
        amount: Number(amount),
      });

      const paymentLink = response.data.paymentLink;

      // We send a specific prefix "💳 PAYMENT_REQUEST|" so the UI knows to render a button
      await sendMessage(
        caseId ?? 0,
        myInfo.id ?? 0,
        `PAYMENT_REQUEST|${amount}|${paymentLink}`,
        "text"
      );

      setPaymentModalOpen(false);
      setAmount("");
    } catch (error) {
      console.error("Failed to generate payment link", error);
    } finally {
      setIsGeneratingLink(false);
    }
  };

  const modalBody = (
    <Box
      sx={{
        ...sxMain,
        backgroundColor: "common.white",
        boxShadow: "0px 0px 6px #00000029",
        borderRadius: 1.25,
        width: "50%",
      }}
    >
      {
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            ...sxHead,
            justifyContent: "space-between",
            height: "3rem",
          }}
        >
          <Typography
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              "&>svg": {
                mr: 1,
              },
            }}
          >
            Schedule Meetinng
          </Typography>
          {
            <IconButton onClick={() => setOpenMoadal(false)}>
              <ImgPath.CloseIcon />
            </IconButton>
          }
        </Box>
      }
      <Box
        sx={{
          height: "calc(100% - 6rem)",
          p: 2,
        }}
      >
        <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
          {formData.map((el: FormDataType) => (
            <Grid key={el.id} size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}>
              {commonFormSwitch({
                formObj: el,
                onChange: (data) =>
                  setFormData(HandleFormChange(data, formData)),
              })}
            </Grid>
          ))}
        </Grid>
      </Box>
      {
        <Box
          sx={{
            px: 2,
            mb: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            height: "3rem",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleScheduleMeet()}
          >
            Schedule
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setOpenMoadal(false)}
            sx={{ ml: 1, borderColor: "primary.main", color: "primary.main" }}
          >
            Cancel
          </Button>
        </Box>
      }
    </Box>
  );

  const getInitials: (orderType: string) => string = (orderType) => {
    if (!orderType) return "";
    const words = orderType.split(" ");
    let initials = "";
    for (let i = 0; i < words.length && i < 2; i++) {
      initials += words[i].charAt(0).toUpperCase();
    }
    return initials;
  };

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#efeae2" }}>
      <Modal
        open={openModal}
        onClose={() => setOpenMoadal(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {modalBody}
      </Modal>

      <StatusUpdateModal
        open={openStatusModal}
        onClose={() => setOpenStatusModal(false)}
        caseStatus={caseStatus}
        onStatusUpdate={handleStatusUpdate}
        currentCaseId={selectedCase?.caseId}
      />
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1,
          // backgroundColor: "#075E54", // WhatsApp darker green for header
          backgroundColor: "primary.main",
          borderBottom: "none",
          flexShrink: 0,
          boxShadow: "0 1px 3px rgba(0,0,0,0.12)"
        }}
      >
        <Avatar
          alt={selectedCase?.orderType}
          sx={{
            backgroundColor: "secondary.main",
            color: "text.primary",
          }}
        >
          {getInitials(selectedCase?.orderType ?? "")}
        </Avatar>
        <Box sx={{ ml: 2, flexGrow: 1 }}>
          <Typography
            fontWeight={600}
            color="text.secondary"
          >{`${selectedCase?.orderType} - ${selectedCase?.caseId} - ${selectedCase?.caseType}`}</Typography>
        </Box>
        {myInfo.userType === "PROFESSIONAL" && (
          <IconButton
            sx={{ color: "white", mr: 1 }}
            onClick={() => setOpenMoadal(true)}
            title="Schedule Meeting"
          >
            <ImgPath.CalenderIcon />
          </IconButton>
        )}
        {myInfo.userType === "PROFESSIONAL" && (
          <IconButton
            sx={{ color: "white", mr: 1 }}
            onClick={handleCallConnection}
            title="Call Client"
          >
            <ImgPath.CallIcon />
          </IconButton>
        )}

        {(myInfo.userType === "PROFESSIONAL" ||
          myInfo.userType === "ADMIN") && (
            <IconButton
              title="Update Status"
              onClick={handleCloseCase}
              sx={{ color: "white", ml: 1 }}
            >
              <ImgPath.TaskAltRoundedIcon />
            </IconButton>
          )}

        {(myInfo.userType === "PROFESSIONAL" ||
          myInfo.userType === "ADMIN") && (
            <IconButton
              title="Reopen Case"
              onClick={handleReOpenCase}
              sx={{ color: "white", ml: 1 }}
            >
              <ImgPath.ReplayRoundedIcon />
            </IconButton>
          )}

        {/* Money Icon for Admin/SuperAdmin */}
        {(myInfo.userType === "ADMIN" || myInfo.userType === "SUPERADMIN") && (
          <IconButton
            title="Send Payment Link"
            onClick={() => setPaymentModalOpen(true)}
            sx={{ color: "white", ml: 1 }}
          >
            <CurrencyRupee />
          </IconButton>
        )}

        {myInfo.userType !== "ADMIN" && myInfo.userType !== "PROFESSIONAL" && (
          <IconButton
            title="SOS - Notify Admin"
            onClick={handleSOSRequest}
            sx={{
              color: "white",
              ml: 1,
              backgroundColor: "rgba(255,0,0,0.2)",
              "&:hover": { backgroundColor: "red" }
            }}
          >
            <Campaign />
          </IconButton>
        )}

        <IconButton sx={{ color: "white", ml: 1 }}>
          <MoreVert />
        </IconButton>
      </Box>

      {/* Chat Messages
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflowY: "auto",
          backgroundColor: "secondary.main",
          display: "flex",
          flexDirection: "column",
          minHeight: 0, // Important for flex child to be scrollable
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "center",
            pb: 2,
            flexShrink: 0,
          }}
        >
          <Typography fontWeight={"bold"}>
            Disclaimer: Anything that is discussed and shared in this chat is
            accessible to the professional.{" "}
          </Typography>
        </Box>
        {messages?.length > 0 ? (
          messages.map((msg, index) => ( 
            
            <Box
              key={index}
              sx={{
                alignSelf:
                  msg.senderUserId === myInfo.id ? "flex-end" : "flex-start",
                backgroundColor:
                  msg.senderUserId === myInfo.id ? "primary.main" : "#ededed",
                color: "#000",
                px: msg.messageType === "text" ? 1.2 : 0.8,
                py: msg.messageType === "text" ? 0.6 : 0.4,
                borderRadius: 2,
                mb: 0.8,
                maxWidth: "70%",
                boxShadow: 0.5,
              }}
            >
              {msg.messageType === "audio" ? (
                <AudioComponent message={msg} />
              ) : msg.messageType === "file" ? (
                <AttachmentComponent
                  downloadImage={(attachmentUrl: string, fileName: string) =>
                    downloadImage(attachmentUrl, fileName)
                  }
                  message={msg}
                  setSelectedDocument={({ attachmentUrl, docType }) =>
                    setSelectedDocument({
                      url: attachmentUrl,
                      docType: docType,
                    })
                  }
                />
              ) : (
                <Typography
                  color={
                    msg.senderUserId === myInfo.id ? "textSecondary" : "#000"
                  }
                  variant="body2"
                >
                  {msg.messageContent}
                </Typography>
              )}

              <Typography
                variant="caption"
                color={
                  msg.senderUserId === myInfo.id ? "textSecondary" : "#000"
                }
                sx={{ float: "right", mt: 0.5 }}
              >
                {dayjs(msg.timestamp).format("MM/DD/YYYY hh:mm A")}
              </Typography>
            </Box>
          ))
        ) : (
          <NoData cstmMsg="No Messages Found." />
        )}
      </Box> */}

      <Box
        sx={{
          flex: 1,
          p: 2,
          overflowY: "auto",
          // backgroundColor: "#efeae2", // WhatsApp beige background
          backgroundColor: "secondary.main",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          // backgroundImage: "url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')", // Optional subtle pattern if desired, or just color
          backgroundSize: "contain"
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "center",
            pb: 2,
            flexShrink: 0,
          }}
        >
          <Typography fontWeight={"bold"} textAlign="center">
            Disclaimer: Anything that is discussed and shared in this chat is
            accessible to the professional.
          </Typography>
        </Box>

        {messages?.length > 0 ? (
          messages.map((msg, index) => {
            const isPayment = msg.messageContent?.startsWith("PAYMENT_REQUEST|");
            let payAmount = "";
            let payUrl = "";

            if (isPayment) {
              const parts = msg.messageContent.split("|");
              payAmount = parts[1];
              payUrl = parts[2];
            }

            return (
              <Box
                key={index}
                sx={{
                  alignSelf: msg.senderUserId === myInfo.id ? "flex-end" : "flex-start",
                  backgroundColor: isPayment
                    ? "#ffffff"
                    : msg.senderUserId === myInfo.id ? "#d9fdd3" : "#ffffff", // WhatsApp bubbles
                  color: "#000000",
                  px: isPayment ? 2 : (msg.messageType === "text" ? 1.2 : 0.8),
                  py: isPayment ? 2 : (msg.messageType === "text" ? 0.6 : 0.4),
                  borderRadius: 1.5,
                  mb: 0.5, // Reduced gap
                  maxWidth: "75%",
                  boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
                  border: isPayment ? "1px solid #e0e0e0" : "none",
                  position: "relative",
                  "&::before": isPayment ? {} : { // Optional bubble tail effect could go here, but keeping it simple for now
                    content: '""',
                    position: "absolute",
                    width: 0,
                    height: 0,
                  }
                }}
              >
                {isPayment ? (
                  /* --- PAYMENT CARD UI --- */
                  <Box sx={{ minWidth: "220px" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <CurrencyRupee sx={{ color: '#2a3162', mr: 1 }} />
                      <Typography variant="subtitle2" fontWeight="bold" sx={{ color: '#2a3162' }}>
                        Payment Request
                      </Typography>
                    </Box>

                    {msg.senderUserId !== myInfo.id ? (
                      <>
                        <Typography variant="body2" sx={{ mb: 2, color: '#444' }}>
                          A payment of <b>₹{payAmount}</b> has been requested for your case.
                        </Typography>
                        <Button
                          variant="contained"
                          fullWidth
                          size="small"
                          startIcon={<CreditCardIcon />}
                          href={payUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            backgroundColor: "#2a3162",
                            "&:hover": { backgroundColor: "#2a3162" },
                            textTransform: "none",
                            fontWeight: "bold",
                            color: "white"
                          }}
                        >
                          Pay Now
                        </Button>
                      </>
                    ) : (
                      /* --- ADMIN VIEW: Just a confirmation that the link was sent --- */
                      <Box sx={{ p: 1, bgcolor: '#f9f9f9', borderRadius: 1, border: '1px dashed #ccc' }}>
                        <Typography variant="caption" color="text.primary">
                          You sent a payment request of <b>₹{payAmount}</b>.
                        </Typography>
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{ mt: 0.5, wordBreak: 'break-all', color: 'primary.main', textDecoration: 'underline', cursor: 'pointer' }}
                          onClick={() => window.open(payUrl, '_blank')}
                        >
                          View sent link
                        </Typography>
                      </Box>
                    )}
                  </Box>

                ) : (
                  /* --- STANDARD MESSAGE / AUDIO / FILE UI --- */
                  <>
                    {msg.messageType === "audio" ? (
                      <AudioComponent message={msg} />
                    ) : msg.messageType === "file" ? (
                      <AttachmentComponent
                        downloadImage={(attachmentUrl: string, fileName: string) =>
                          downloadImage(attachmentUrl, fileName)
                        }
                        message={msg}
                        setSelectedDocument={({ attachmentUrl, docType }) =>
                          setSelectedDocument({
                            url: attachmentUrl,
                            docType: docType,
                          })
                        }
                      />
                    ) : (
                      <Typography
                        color="#000" // Always black text for WhatsApp style
                        variant="body2"
                        sx={{ wordBreak: "break-word" }}
                      >
                        {msg.messageContent}
                      </Typography>
                    )}
                  </>
                )}

                <Typography
                  variant="caption"
                  sx={{
                    color: "#667781",
                    fontSize: "0.68rem",
                    marginTop: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "4px"
                  }}
                >
                  {dayjs(msg.timestamp).format("MM/DD/YYYY hh:mm A")}
                </Typography>
              </Box>
            );
          })
        ) : (
          <NoData cstmMsg="No Messages Found." />
        )}
      </Box>

      {isRecording && (
        <Box sx={{ flexShrink: 0, p: 2 }}>
          <canvas
            ref={canvasRef}
            width={300}
            height={60}
            style={{ background: "#eee", margin: "8px auto", borderRadius: 4 }}
          />
        </Box>
      )}

      {recordedAudioUrl && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            pb: 1,
            justifyContent: "flex-start",
            flexShrink: 0,
          }}
        >
          <audio controls src={recordedAudioUrl} style={{ height: 32 }} />
          <IconButton onClick={handleDeleteRecording} color="error">
            <DeleteForeverRounded />
          </IconButton>
        </Box>
      )}

      <Paper
        elevation={0}
        sx={{
          display: "flex",
          alignItems: "center",
          px: 1,
          py: 1,
          backgroundColor: "#f0f2f5", // WhatsApp input area background
          flexShrink: 0,
          minHeight: "62px"
        }}
      >
        <IconButton component="label" sx={{ color: "#54656f" }}>
          <AttachFile />
          <input
            type="file"
            hidden
            multiple
            onChange={handleAttachmentUpload}
          />
        </IconButton>

        <Box
          sx={{
            flex: 1,
            ml: 1,
            backgroundColor: "white",
            borderRadius: "24px",
            px: 2,
            py: 0.5,
            display: "flex",
            alignItems: "center"
          }}
        >
          <InputBase
            value={input}
            sx={{ flex: 1 }}
            placeholder="Type a message"
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => handleEnterPress(e)}
            multiline
            maxRows={4}
          />
        </Box>

        <IconButton
          onClick={isRecording ? handleStopRecording : handleStartRecording}
          color={isRecording ? "error" : "default"}
          sx={{ color: isRecording ? "error" : "#54656f", mx: 0.5 }}
        >
          <Mic />
        </IconButton>

        <IconButton
          onClick={handleSend}
          disabled={
            !input.trim() && !(recordedAudioUrl && recordingChunks.length)
          }
          sx={{
            color: (!input.trim() && !(recordedAudioUrl && recordingChunks.length)) ? "#aebac1" : "#00a884"
          }}
        >
          <Send />
        </IconButton>
      </Paper>
      {selectedDocument &&
        (selectedDocument.docType == "image" ? (
          <Box
            onClick={() => setSelectedDocument({ docType: null, url: null })}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              cursor: "zoom-out",
            }}
          >
            <img
              src={selectedDocument.url ?? ""}
              alt="Full Preview"
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                borderRadius: "8px",
                boxShadow: "0 0 20px rgba(0,0,0,0.5)",
              }}
            />
          </Box>
        ) : selectedDocument.docType == "video" ? (
          <Box
            onClick={() => setSelectedDocument({ docType: null, url: null })}
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              cursor: "zoom-out",
            }}
          >
            <video
              src={selectedDocument.url ?? ""}
              controls
              autoPlay
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                borderRadius: "8px",
                boxShadow: "0 0 20px rgba(0,0,0,0.5)",
              }}
            />
          </Box>
        ) : (
          <></>
        ))}

      {/* Payment Modal */}
      <Dialog open={paymentModalOpen} onClose={() => setPaymentModalOpen(false)}>
        <DialogTitle>Send Payment Link</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Enter the amount to generate a payment link for this case.
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="Amount"
            type="number"
            fullWidth
            variant="outlined"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPaymentModalOpen(false)}>Cancel</Button>
          <Button
            onClick={handleSendPaymentLink}
            variant="contained"
            disabled={isGeneratingLink || !amount}
          >
            {isGeneratingLink ? "Generating..." : "Send Link"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SingleChatScreen1;
const sxHead = {
  backgroundColor: "#075E54",
  px: 2,
  "& >p:first-of-type": {
    color: "white",
  },
  "& >button": {
    color: "white",
  },
};
const sxMain = {
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  transform: `translate(-${50}%, -${50}%)`,
  position: "absolute",
  outline: "none",
  // overflow: "auto",
  borderRadius: 1.25,
};
